module.exports = __webpack_public_path__ + "static/img/hs_js_10.781510d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/hs_js_10.png
// module id = x0sx
// module chunks = 1